module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-regular.5f070b04.woff2";